import { createPaginatedInfiniteQuery, type QueryApi } from "../../api/query";

export function createUseShopSearch($api: QueryApi) {
  const usePaginatedInfiniteQuery = createPaginatedInfiniteQuery($api);

  return function useShopSearch(params: { term: string; size?: number; categoryId?: string }) {
    return usePaginatedInfiniteQuery(
      "/shops/search",
      { term: params.term, size: params.size ?? 20, categoryId: params.categoryId },
      { enabled: params.term.length >= 2, staleTime: 30_000 },
    );
  };
}
